import React from 'react'
import {browserHistory} from 'react-router'
import _ from 'lodash'
import $ from 'jquery';

require('jquery-bbq');


class BaseQueryControlComponent extends React.Component {

  getQuery() {
    return $.deparam(window.location.search.substring(1));
  }

  getQueryParam(key) {
    return this.getQuery()[key];
  }

  getUpdatedQuery(newQuery, paramsToRemoveIfNotPresent) {
    let query = this.getQuery();
    _.map(newQuery, (item, key) => {
      if (item == 'Invalid date') {
        // query[key] = ''; 
        delete query[key];
      } else {
        let itemTrimmed = item ? item.trim() : '';
        if(itemTrimmed != ""){
          query[key] = itemTrimmed;
        } 
      }
    });
    _.map(query, (item, key) => {
      if (paramsToRemoveIfNotPresent.indexOf(key) != -1 && !newQuery[key]) {
        delete query[key]
      }
    });
    return query;
  }

  updateSearchString(newQuery) {
    if (!_.isEmpty(newQuery)) {
      browserHistory.push(window.location.pathname + '?' + $.param(newQuery));
    }
  }

  updateCurrentQuery(newQuery) {
    let query = this.getQuery();
    _.map(newQuery, (item, key) => {
      query[key] = item
    });
    let search = '';
    if (!_.isEmpty(query)) {
      search += '?' + $.param(query);
    }
    browserHistory.push(window.location.pathname + search);
  }
}

BaseQueryControlComponent.displayName = 'BaseQueryControlComponent';
export default BaseQueryControlComponent;



// WEBPACK FOOTER //
// ./src/components/common/BaseQueryControlComponent.js